const en_US = {

  'start' : 'Start',
  'complete' : 'Complete',
  'completed' : 'Completed',
  'check' : 'Check',
  'buy' : 'Buy',
  'balance' : 'Balance',
  'next' : 'Next step',
  'exchange_rate' : 'Rate',
  'exchange' : 'Exchange',
  'volume' : 'Vol.',
  'latest_exchange' : 'Latest',
  'annualized_income' : 'APR',
  'total_balance' : 'Total assets',
  'close' : 'Close',
  'price' : 'Ref.',
  'no_data' : 'No data',
  'flash_exchange' : 'Instant Exchange',
  'tips' : 'Tips',

}
export default en_US
